import { a as or } from "../toString-3b91b335.mjs";
import { l as ar, e as ir, k as D, d as v, m as G, n as sr, o as ur, p as K, q as fr, s as cr, r as R, t as lr, U as F, a as m, u as y, v as H, i as gr, b as br, g as pr, j as yr } from "../_getTag-4e44633b.mjs";
import { r as dr, S as d, i as O, a as q, b as Tr } from "../isArray-0d9c7aaa.mjs";
import { b as vr, c as Y, t as mr, i as Or } from "../identity-6eafe87b.mjs";
import { b as Ar } from "../_baseSlice-4d543985.mjs";
function hr(r, e) {
  for (var n = -1, t = r == null ? 0 : r.length; ++n < t && e(r[n], n, r) !== !1; )
    ;
  return r;
}
var $r = function() {
  try {
    var r = ar(Object, "defineProperty");
    return r({}, "", {}), r;
  } catch {
  }
}();
const T = $r;
function W(r, e, n) {
  e == "__proto__" && T ? T(r, e, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : r[e] = n;
}
var Sr = Object.prototype, jr = Sr.hasOwnProperty;
function J(r, e, n) {
  var t = r[e];
  (!(jr.call(r, e) && ir(t, n)) || n === void 0 && !(e in r)) && W(r, e, n);
}
function b(r, e, n, t) {
  var o = !n;
  n || (n = {});
  for (var i = -1, s = e.length; ++i < s; ) {
    var u = e[i], f = t ? t(n[u], r[u], u, n, r) : void 0;
    f === void 0 && (f = r[u]), o ? W(n, u, f) : J(n, u, f);
  }
  return n;
}
function wr(r, e) {
  return r && b(e, D(e), r);
}
function Pr(r) {
  var e = [];
  if (r != null)
    for (var n in Object(r))
      e.push(n);
  return e;
}
var Fr = Object.prototype, Cr = Fr.hasOwnProperty;
function xr(r) {
  if (!v(r))
    return Pr(r);
  var e = G(r), n = [];
  for (var t in r)
    t == "constructor" && (e || !Cr.call(r, t)) || n.push(t);
  return n;
}
function A(r) {
  return sr(r) ? ur(r, !0) : xr(r);
}
function Lr(r, e) {
  return r && b(e, A(e), r);
}
var Q = typeof exports == "object" && exports && !exports.nodeType && exports, C = Q && typeof module == "object" && module && !module.nodeType && module, Ir = C && C.exports === Q, x = Ir ? dr.Buffer : void 0, L = x ? x.allocUnsafe : void 0;
function Er(r, e) {
  if (e)
    return r.slice();
  var n = r.length, t = L ? L(n) : new r.constructor(n);
  return r.copy(t), t;
}
function _r(r, e) {
  var n = -1, t = r.length;
  for (e || (e = Array(t)); ++n < t; )
    e[n] = r[n];
  return e;
}
function Mr(r, e) {
  return b(r, K(r), e);
}
var Ur = fr(Object.getPrototypeOf, Object);
const h = Ur;
var Nr = Object.getOwnPropertySymbols, Br = Nr ? function(r) {
  for (var e = []; r; )
    R(e, K(r)), r = h(r);
  return e;
} : cr;
const X = Br;
function Dr(r, e) {
  return b(r, X(r), e);
}
function Z(r) {
  return lr(r, A, X);
}
var Gr = Object.prototype, Kr = Gr.hasOwnProperty;
function Rr(r) {
  var e = r.length, n = new r.constructor(e);
  return e && typeof r[0] == "string" && Kr.call(r, "index") && (n.index = r.index, n.input = r.input), n;
}
function $(r) {
  var e = new r.constructor(r.byteLength);
  return new F(e).set(new F(r)), e;
}
function Hr(r, e) {
  var n = e ? $(r.buffer) : r.buffer;
  return new r.constructor(n, r.byteOffset, r.byteLength);
}
var qr = /\w*$/;
function Yr(r) {
  var e = new r.constructor(r.source, qr.exec(r));
  return e.lastIndex = r.lastIndex, e;
}
var I = d ? d.prototype : void 0, E = I ? I.valueOf : void 0;
function Wr(r) {
  return E ? Object(E.call(r)) : {};
}
function Jr(r, e) {
  var n = e ? $(r.buffer) : r.buffer;
  return new r.constructor(n, r.byteOffset, r.length);
}
var Qr = "[object Boolean]", Xr = "[object Date]", Zr = "[object Map]", Vr = "[object Number]", zr = "[object RegExp]", kr = "[object Set]", re = "[object String]", ee = "[object Symbol]", ne = "[object ArrayBuffer]", te = "[object DataView]", oe = "[object Float32Array]", ae = "[object Float64Array]", ie = "[object Int8Array]", se = "[object Int16Array]", ue = "[object Int32Array]", fe = "[object Uint8Array]", ce = "[object Uint8ClampedArray]", le = "[object Uint16Array]", ge = "[object Uint32Array]";
function be(r, e, n) {
  var t = r.constructor;
  switch (e) {
    case ne:
      return $(r);
    case Qr:
    case Xr:
      return new t(+r);
    case te:
      return Hr(r, n);
    case oe:
    case ae:
    case ie:
    case se:
    case ue:
    case fe:
    case ce:
    case le:
    case ge:
      return Jr(r, n);
    case Zr:
      return new t();
    case Vr:
    case re:
      return new t(r);
    case zr:
      return Yr(r);
    case kr:
      return new t();
    case ee:
      return Wr(r);
  }
}
var _ = Object.create, pe = function() {
  function r() {
  }
  return function(e) {
    if (!v(e))
      return {};
    if (_)
      return _(e);
    r.prototype = e;
    var n = new r();
    return r.prototype = void 0, n;
  };
}();
const ye = pe;
function de(r) {
  return typeof r.constructor == "function" && !G(r) ? ye(h(r)) : {};
}
var Te = "[object Map]";
function ve(r) {
  return O(r) && m(r) == Te;
}
var M = y && y.isMap, me = M ? H(M) : ve;
const Oe = me;
var Ae = "[object Set]";
function he(r) {
  return O(r) && m(r) == Ae;
}
var U = y && y.isSet, $e = U ? H(U) : he;
const Se = $e;
var je = 1, we = 2, Pe = 4, V = "[object Arguments]", Fe = "[object Array]", Ce = "[object Boolean]", xe = "[object Date]", Le = "[object Error]", z = "[object Function]", Ie = "[object GeneratorFunction]", Ee = "[object Map]", _e = "[object Number]", k = "[object Object]", Me = "[object RegExp]", Ue = "[object Set]", Ne = "[object String]", Be = "[object Symbol]", De = "[object WeakMap]", Ge = "[object ArrayBuffer]", Ke = "[object DataView]", Re = "[object Float32Array]", He = "[object Float64Array]", qe = "[object Int8Array]", Ye = "[object Int16Array]", We = "[object Int32Array]", Je = "[object Uint8Array]", Qe = "[object Uint8ClampedArray]", Xe = "[object Uint16Array]", Ze = "[object Uint32Array]", a = {};
a[V] = a[Fe] = a[Ge] = a[Ke] = a[Ce] = a[xe] = a[Re] = a[He] = a[qe] = a[Ye] = a[We] = a[Ee] = a[_e] = a[k] = a[Me] = a[Ue] = a[Ne] = a[Be] = a[Je] = a[Qe] = a[Xe] = a[Ze] = !0;
a[Le] = a[z] = a[De] = !1;
function p(r, e, n, t, o, i) {
  var s, u = e & je, f = e & we, nr = e & Pe;
  if (n && (s = o ? n(r, t, o, i) : n(r)), s !== void 0)
    return s;
  if (!v(r))
    return r;
  var S = q(r);
  if (S) {
    if (s = Rr(r), !u)
      return _r(r, s);
  } else {
    var g = m(r), j = g == z || g == Ie;
    if (gr(r))
      return Er(r, u);
    if (g == k || g == V || j && !o) {
      if (s = f || j ? {} : de(r), !u)
        return f ? Dr(r, Lr(s, r)) : Mr(r, wr(s, r));
    } else {
      if (!a[g])
        return o ? r : {};
      s = be(r, g, u);
    }
  }
  i || (i = new br());
  var w = i.get(r);
  if (w)
    return w;
  i.set(r, s), Se(r) ? r.forEach(function(c) {
    s.add(p(c, e, n, c, r, i));
  }) : Oe(r) && r.forEach(function(c, l) {
    s.set(l, p(c, e, n, l, r, i));
  });
  var tr = nr ? f ? Z : pr : f ? A : D, P = S ? void 0 : tr(r);
  return hr(P || r, function(c, l) {
    P && (l = c, c = r[l]), J(s, l, p(c, e, n, l, r, i));
  }), s;
}
function Ve(r) {
  var e = r == null ? 0 : r.length;
  return e ? r[e - 1] : void 0;
}
function ze(r, e) {
  return e.length < 2 ? r : vr(r, Ar(e, 0, -1));
}
function ke(r, e) {
  return e = Y(e, r), r = ze(r, e), r == null || delete r[mr(Ve(e))];
}
var rn = "[object Object]", en = Function.prototype, nn = Object.prototype, rr = en.toString, tn = nn.hasOwnProperty, on = rr.call(Object);
function an(r) {
  if (!O(r) || Tr(r) != rn)
    return !1;
  var e = h(r);
  if (e === null)
    return !0;
  var n = tn.call(e, "constructor") && e.constructor;
  return typeof n == "function" && n instanceof n && rr.call(n) == on;
}
function sn(r) {
  return an(r) ? void 0 : r;
}
var N = d ? d.isConcatSpreadable : void 0;
function un(r) {
  return q(r) || yr(r) || !!(N && r && r[N]);
}
function er(r, e, n, t, o) {
  var i = -1, s = r.length;
  for (n || (n = un), o || (o = []); ++i < s; ) {
    var u = r[i];
    e > 0 && n(u) ? e > 1 ? er(u, e - 1, n, t, o) : R(o, u) : t || (o[o.length] = u);
  }
  return o;
}
function fn(r) {
  var e = r == null ? 0 : r.length;
  return e ? er(r, 1) : [];
}
function cn(r, e, n) {
  switch (n.length) {
    case 0:
      return r.call(e);
    case 1:
      return r.call(e, n[0]);
    case 2:
      return r.call(e, n[0], n[1]);
    case 3:
      return r.call(e, n[0], n[1], n[2]);
  }
  return r.apply(e, n);
}
var B = Math.max;
function ln(r, e, n) {
  return e = B(e === void 0 ? r.length - 1 : e, 0), function() {
    for (var t = arguments, o = -1, i = B(t.length - e, 0), s = Array(i); ++o < i; )
      s[o] = t[e + o];
    o = -1;
    for (var u = Array(e + 1); ++o < e; )
      u[o] = t[o];
    return u[e] = n(s), cn(r, this, u);
  };
}
function gn(r) {
  return function() {
    return r;
  };
}
var bn = T ? function(r, e) {
  return T(r, "toString", {
    configurable: !0,
    enumerable: !1,
    value: gn(e),
    writable: !0
  });
} : Or;
const pn = bn;
var yn = 800, dn = 16, Tn = Date.now;
function vn(r) {
  var e = 0, n = 0;
  return function() {
    var t = Tn(), o = dn - (t - n);
    if (n = t, o > 0) {
      if (++e >= yn)
        return arguments[0];
    } else
      e = 0;
    return r.apply(void 0, arguments);
  };
}
var mn = vn(pn);
const On = mn;
function An(r) {
  return On(ln(r, void 0, fn), r + "");
}
var hn = 1, $n = 2, Sn = 4, jn = An(function(r, e) {
  var n = {};
  if (r == null)
    return n;
  var t = !1;
  e = or(e, function(i) {
    return i = Y(i, r), t || (t = i.length > 1), i;
  }), b(r, Z(r), n), t && (n = p(n, hn | $n | Sn, sn));
  for (var o = e.length; o--; )
    ke(n, e[o]);
  return n;
});
const wn = jn;
function In({
  openingHours: r
}) {
  const e = r.reduce(
    (n, t) => (n[t.orderFormat] || (n[t.orderFormat] = {
      orderFormats: t.orderFormat,
      intervals: [],
      isDefault: t.isDefault
    }), n[t.orderFormat].intervals.push(wn(t, "orderFormat")), n),
    {}
  );
  return Object.values(e);
}
export {
  In as default
};
